import React, { useState } from "react";
import "./Dialog.css";
import { Dialog, DialogContent, Typography } from "@mui/material";
import { theme } from "../../Themes/Themes";
import useStore from "../../Store/Store";
import DialogButton from "./DialogButton";

const RepositorySettingsDialog = () => {
  const { dialog, setDialog, currentRepo } = useStore((state) => ({
    dialog: state.dialog,
    setDialog: state.setDialog,
    currentRepo: state.currentRepo,
  }));

  const [repoPath, setRepoPath] = useState(() => {
    const storedPath = localStorage.getItem(`vscodeRepoPath_${currentRepo}`);
    return storedPath || "";
  });

  const handleSave = () => {
    if (repoPath.trim()) {
      localStorage.setItem(`vscodeRepoPath_${currentRepo}`, repoPath.trim());
      // Clear any existing success flag to re-prompt for verification
      localStorage.removeItem(`vscodeWorking_${currentRepo}`);
    } else {
      localStorage.removeItem(`vscodeRepoPath_${currentRepo}`);
      localStorage.removeItem(`vscodeWorking_${currentRepo}`);
    }
    closeDialog();
  };

  const closeDialog = () => {
    setDialog("");
  };

  return (
    <Dialog
      open={dialog.type === "REPOSITORY_SETTINGS_DIALOG"}
      sx={{
        "& .MuiPaper-root": {
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          borderRadius: "30px",
          width: "50vw",
        },
      }}
      onClose={closeDialog}
    >
      <DialogContent className="DialogContent">
        <br />
        <Typography
          textAlign={"center"}
          mx={3}
          my={0.8}
          fontSize="20px"
          fontWeight="Normal"
          color={theme.custom.darkerGrey}
          sx={{ paddingBottom: "10px" }}
        >
          Repository Settings
        </Typography>
        <Typography
          textAlign={"center"}
          mx={3}
          my={0.8}
          fontSize="16px"
          fontWeight="Light"
          color={theme.custom.darkerGrey}
          sx={{ paddingBottom: "20px" }}
        >
          Configure the local repository path if you want to open code files
          directly in VSCode. This should be the absolute path to where you have
          cloned this repository locally.
        </Typography>

        <div
          style={{
            padding: "0 20px",
            marginBottom: "20px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography
            textAlign={"center"}
            fontSize="14px"
            fontWeight="Normal"
            color={theme.custom.darkerGrey}
            sx={{ marginBottom: "8px" }}
          >
            Local Repository Path:
          </Typography>
          <input
            style={{
              width: "100%",
              maxWidth: "400px",
              padding: "12px 16px",
              borderRadius: "30px",
              border: `2px solid ${theme.custom.lightGrey}`,
              fontSize: "14px",
              fontFamily: "inherit",
              outline: "none",
              transition: "border-color 0.2s",
              textAlign: "center",
            }}
            value={repoPath}
            placeholder={`/Users/yourname/path/to/${currentRepo}`}
            onChange={(e) => setRepoPath(e.target.value)}
            onFocus={(e) => {
              e.target.style.borderColor = theme.custom.lighterPink;
            }}
            onBlur={(e) => {
              e.target.style.borderColor = theme.custom.lightGrey;
            }}
          />
          <Typography
            textAlign={"center"}
            fontSize="12px"
            fontWeight="Light"
            color={theme.custom.darkerGrey}
            sx={{ marginTop: "8px" }}
          >
            Example: /Users/john/Desktop/{currentRepo} or C:\Users\John\Desktop\
            {currentRepo}
          </Typography>
        </div>

        <div
          className="DialogButtonGroupHorizontal"
          style={{ paddingBottom: "10px" }}
        >
          <DialogButton
            onClick={closeDialog}
            text="Cancel"
            style={{ marginRight: "30px" }}
          />
          <DialogButton
            onClick={handleSave}
            text="Save"
            style={{ marginLeft: "30px" }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default RepositorySettingsDialog;
